module.exports = "/assets/kinley-2020.jpg?IMGKq+j";